import React from 'react';
import DashBoardHeader from '../header_dashboard/dashboard_header';
import './contact_support.less';
import {Link} from 'react-router';
import ProfileNavBar from './profile_navbar/profile_navbar';
import {routerActions} from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import authActions from '../auth/auth_actions';
import LoggedinFooter from '../footer/loggedin_footer';
import profileActions from '../profile/profile_actions';
import MediaQuery from 'react-responsive';
import validate from '../util/validate';
import {toTitleCase, join} from '../util/common';
import ShowError from '../components/error/show_error';
import Constants from '../common_constants';
import Select from 'react-select';
import ReactDOM from 'react-dom';
import cookies from '../util/cookie';
import LogoutPopUp from '../components/logoutPopUp/logout_pop_up';
import CONSTANTS from '../common_constants';
import SuccessMessage from '../components/success/success_msg';

class ContactSupportDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            email: '',
            message: '',
            ajaxInProgress: false,
            validationError: {},
            issue: '',
            successMsg : ''
        }
        this.sendMessage = this.sendMessage.bind(this);
        this.update = this.update.bind(this);
        this.updateSelectValue = this.updateSelectValue.bind(this);
    }
    update(name, event) {
        const stateObj = {};
        stateObj[name] = event.target.value;
        this.setState(stateObj);
    }
    updateSelectValue(e) {
        this.setState({issue: e.value});
    }
    componentDidMount(){
      const firstChild = 0;
      const spanElement = ReactDOM.findDOMNode(this.refs.stateSelect).getElementsByClassName("Select-arrow-zone")[firstChild].childNodes[firstChild];
      spanElement.className = '';
      spanElement.className = 'icon-down-arrow-outline';
    }
    sendMessage(e) {
        e.preventDefault();
        this.setState({successMsg:"",error:null});
        const self = this;
        const validationError = {
            issue: (this.state.issue == ''),
            name: !validate.name(this.state.name),
            email: !validate.email(this.state.email),
            message: (this.state.message == '')
        };

        const validationMap = {
            issue: 'Issue',
            name: 'Name',
            email: 'Email',
            message: 'Message'
        };

        let errorMsg = "";
        const validationFields = [];
        Object.keys(validationError).forEach((key) => {
            if (validationError[key])
                validationFields.push(validationMap[key]);
            }
        );
        if (validationFields.length) {
          errorMsg = 'Please enter valid ' + join(validationFields, (item, idx) => {
              if (validationFields.length === 1)
                  return "";
              if (idx > 0 && idx < validationFields.length - 1)
                  return ", ";
              else if (idx === validationFields.length - 1)
                  return " and ";
              return "";
          }) + '.';
        } else {
          this.setState({error: errorMsg, validationError: validationError});
        }
        if (errorMsg) {
          this.setState({error: errorMsg, validationError: validationError});
          return;
        }
        let parameters = {
            message: this.state.message,
            SupportTypeId : this.state.issue
        }
        this.setState({ajaxInProgress: true});
        this.props.profileActions.contactSupport(parameters).then(() => {
            this.setState({name : '', email : '', message : '', ajaxInProgress : false, validationError : {}, issue : '',successMsg:"Thanks! We will contact you soon."});
        }, (errorRes) => {
            if (errorRes.error === CONSTANTS.sessionInvalid) {
              this.setState({
                  ajaxInProgress: false});
                  this.props.authActions.sessionValid(false);
                  cookies.delete('_sd');
                  return ;
              }
            this.setState({ajaxInProgress: false});
            this.setState({error: errorRes.error, validationError: validationError});
        })

    }
    render() {
        const self = this;
        let {ajaxInProgress} = this.state;
        const constants = Constants.issue;
        const loader = <div className="loader"></div>;
        let selectedValue = this.state.issue;
        return (
            <div className="contact-support-main-wrap">
                <MediaQuery query='(min-width: 768px)'>
                    <div className="main-heading">Contact Support</div>
                </MediaQuery>
                <div className="error-div">
                    {this.state.error && <ShowError errorMessage={this.state.error}/>}
                    {this.state.successMsg != '' && <SuccessMessage successMessage = {this.state.successMsg} />}
                </div>
                <div className="heading">Fill out the form below</div>
                <form className="send-message-form">
                    <div className="input-set">
                        <MediaQuery query='(min-width: 768px)'>
                            <label>Issue</label>
                        </MediaQuery>
                        <span className="selectSpan">
                            <Select ref="stateSelect"searchable={false} options={constants} onChange={this.updateSelectValue} className="select" value={selectedValue} clearable={false}></Select>
                        </span>
                    </div>
                    <div className="input-set">
                        <MediaQuery query='(min-width: 768px)'>
                            <label>Name</label>
                        </MediaQuery>
                        <span><input type="text" onChange={this.update.bind(self, 'name')} value={this.state.name}placeholder="Your name" className="input"/></span>
                    </div>
                    <div className="input-set">
                        <MediaQuery query='(min-width: 768px)'>
                            <label>Email</label>
                        </MediaQuery>
                        <span><input placeholder="Your email address" type="text" value={this.state.email}onChange={this.update.bind(self, 'email')} className="input"/></span>
                    </div>
                    <div className="input-set">
                        <MediaQuery query='(min-width: 768px)'>
                            <label>Message</label>
                        </MediaQuery>
                        <span><input placeholder="Type your message" type="text" value={this.state.message}onChange={this.update.bind(self, 'message')} className="input"/></span>
                    </div>
                    <div className="input-set">
                        <button onClick={this.sendMessage} className="btn orange send-msg-btn">{ajaxInProgress ? loader : 'Send message'}</button>
                    </div>
                </form>
            </div>
        )
    }
}
class ContactSupport extends React.Component {
    constructor(props) {
        super(props);
        this.logout = this.logout.bind(this);
    }

    logout() {
      this.props.authActions.logout().always(() => {
          cookies.delete('_sd');
          document.location.href = '/';
      });
    }

    render() {
        const {props, state} = this;
        const {userData} = props.authState;
        let sessionValid = true ;
        if("sessionValid" in props.authState.userData)
            sessionValid = props.authState.userData.sessionValid
        let user = {
            name: '',
            imageUrl: '',
            isVerified: '',
            creditAmount: ''
        };

        if (props.authState) {
            user.name = userData.name;
            user.imageUrl = userData.profileImageUrl;
            user.isVerified = userData.isVerified;
            user.creditAmount = userData.creditAmount
        }

        return (
            <div className="account-details-wrap">
                <DashBoardHeader user={user} logout={this.logout} />
                <LogoutPopUp isOpen={!sessionValid}></LogoutPopUp>
                <div className="account-header-wrap">
                    <div className="wrapper">
                        <h2 className="page-header account-page-header">Account</h2>
                    </div>
                </div>
                <div className="wrapper account-wrapper">
                    <div className="profile-nav-bar-component">
                        <ProfileNavBar pathname={this.props.location.pathname} userData={user}/>
                    </div>
                    <div className="account-details-component">
                        <ContactSupportDetails authActions = {this.props.authActions}profileActions={this.props.profileActions}/>
                    </div>
                </div>
                  <LoggedinFooter />
            </div>
        )
    }
}

ContactSupport = connect((state) => {
    return {authState: state.app.auth}
}, (dispatch) => {
    return {
        routerActions: bindActionCreators(routerActions, dispatch),
        authActions: bindActionCreators(authActions, dispatch),
        profileActions: bindActionCreators(profileActions, dispatch)
    }
})(ContactSupport);

export default ContactSupport;



// WEBPACK FOOTER //
// app/profile/contact_support.jsx